const SFAPI_VERSION = "2023-04";
export {
  SFAPI_VERSION
};
//# sourceMappingURL=storefront-api-constants.mjs.map
